import script from "./AssessmentAvailability.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentAvailability.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentAvailability.vue?vue&type=style&index=0&id=1cbd6637&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cbd6637"]])

export default __exports__